/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React from "react";
import PropTypes from "prop-types";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

class ConfirmationModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      title: "",
      text: "",
      buttonColor: "",
      buttonText: "",
      callback: function () {},
    };

    this.changeContent = this.changeContent.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
  }

  changeContent(title, text, buttonColor, buttonText, callback) {
    this.setState({
      modal: true,
      title: title,
      text: text,
      buttonColor: buttonColor,
      buttonText: buttonText,
      callback: callback,
    });
  }

  show(value) {
    this.setState({
      modal: true,
    });
  }

  hide(value) {
    this.setState({
      modal: false,
    });

    this.state.callback(value);
  }

  render() {
    return (
      <div>
        <Modal
          size="lg"
          isOpen={this.state.modal}
          keyboard={false}
          backdrop="static"
          toggle={this.hide}
          className={this.props.className}>
          <ModalHeader>{this.state.title}</ModalHeader>
          <ModalBody style={{ whiteSpace: "pre-wrap" }}>{this.state.text}</ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => this.hide(false)}>
              Retour
            </Button>{" "}
            <Button color={this.state.buttonColor} onClick={() => this.hide(true)}>
              {this.state.buttonText}
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

ConfirmationModal.propTypes = {
  modalOpen: PropTypes.bool,
};

export default ConfirmationModal;
